import { Alert, AlertIcon, Button, HStack, Stack } from "@chakra-ui/react";
import { FaSync } from "react-icons/fa";
import AnalysisProgressNotice from "./AnalysisProgressNotice";
import AnalyzeBtn from "./AnalyzeBtn";

export default function FilterActionsBar({
  analysisAvailability,
  analysisProgress,
  analysisReadiness,
  handleCancelAnalysis,
  handleReset,
  handleResetAllFilters,
  handleRunReport,
  isAnalyzing,
  isLoading,
  selectedReport,
  showReport,
  t,
  toast,
  toastMessages,
  usageLimitReached,
}) {
  return (
    <Stack
      direction={{ base: "column", lg: "row" }}
      justify="space-between"
      align={{ base: "stretch", lg: "center" }}
      spacing={1}
    >
      {!analysisAvailability?.isAvailable && analysisAvailability?.message ? (
        <Alert status="warning" borderRadius="md" py={2} px={3} flex="1">
          <AlertIcon />
          {analysisAvailability.message}
        </Alert>
      ) : !analysisReadiness?.isReady && analysisReadiness?.message ? (
        <Alert status="warning" borderRadius="md" py={2} px={3} flex="1">
          <AlertIcon />
          {analysisReadiness.message}
        </Alert>
      ) : null}
      <AnalysisProgressNotice progress={analysisProgress} t={t} />
      <HStack spacing={1} flexWrap="wrap">
        <Button
          variant="ghost"
          colorScheme="orange"
          size="sm"
          onClick={() => handleResetAllFilters(toastMessages, toast)}
          leftIcon={<FaSync />}
        >
          {t("reports.resetFilters", "إعادة تعيين الفلاتر")}
        </Button>
        {(selectedReport || showReport) && (
          <Button
            variant="ghost"
            colorScheme="red"
            size="sm"
            onClick={handleReset}
            leftIcon={<FaSync />}
          >
            {t("reports.resetAll", "إعادة تعيين الكل")}
          </Button>
        )}
      </HStack>
      <AnalyzeBtn
        analysisAvailability={analysisAvailability}
        analysisReadiness={analysisReadiness}
        handleCancelAnalysis={handleCancelAnalysis}
        handleRunReport={handleRunReport}
        isAnalyzing={isAnalyzing}
        isLoading={isLoading}
        selectedReport={selectedReport}
        t={t}
        usageLimitReached={usageLimitReached}
      />
    </Stack>
  );
}
